<script>
  import { Input } from '@sveltestrap/sveltestrap';

  export let size = 'sm';
  export let value;

  export let onChange = () => {};

  const options = [
    'none',
    'block',
    'inline',
    'flex',
    'grid',
    'inherit',
    'initial',
    'inline-block',
    'inline-flex',
    'inline-grid'
  ];

  let lastActiveValue = value !== 'none' ? value : 'initial';

  $: if (value !== 'none') {
    lastActiveValue = value;
  }
</script>

<div class="d-flex align-items-center">
  <Input
    type="switch"
    class="me-1"
    checked={value !== 'none'}
    on:change={(e) => {
      const isEnabled = e.target.checked;
      onChange(isEnabled ? lastActiveValue : 'none');
    }}
  />
  <Input
    type="select"
    disabled={value === 'none'}
    {...$$restProps}
    {value}
    bsSize={size}
    on:input={(e) => onChange(e.target.value)}
  >
    {#each options as option}
      <option value={option}>
        {option}
      </option>
    {/each}
  </Input>
</div>
